// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/cell/index.css
// module id = 443
// module chunks = 32